import React, { SetStateAction, createContext, useState } from "react";

import {
  FairPaySurveyPartnership,
  FairPaySurveyResponse,
} from "features/FairPaySurvey/schemas";

interface FairPaySurveyResponseContextInterface {
  fairPaySurveyResponse: FairPaySurveyResponse | null;
  setFairPaySurveyResponse: React.Dispatch<
    SetStateAction<FairPaySurveyResponse | null>
  >;
  fairPaySurveyPartnerships: FairPaySurveyPartnership[] | null;
  setFairPaySurveyPartnerships: React.Dispatch<
    SetStateAction<FairPaySurveyPartnership[] | null>
  >;
}

const defaultContextMissingFunction = () => {
  throw new Error("context is missing");
};

const defaultInterface = {
  fairPaySurveyResponse: null,
  setFairPaySurveyResponse: defaultContextMissingFunction,
  fairPaySurveyPartnerships: null,
  setFairPaySurveyPartnerships: defaultContextMissingFunction,
};

const FairPaySurveyResponseContext =
  createContext<FairPaySurveyResponseContextInterface>(defaultInterface);

interface FairPaySurveyResponseProviderProps {
  children: React.ReactNode;
}

const FairPaySurveyResponseProvider = ({
  children,
}: FairPaySurveyResponseProviderProps) => {
  const [fairPaySurveyResponse, setFairPaySurveyResponse] =
    useState<FairPaySurveyResponse | null>(null);
  const [fairPaySurveyPartnerships, setFairPaySurveyPartnerships] = useState<
    FairPaySurveyPartnership[] | null
  >(null);

  return (
    <FairPaySurveyResponseContext.Provider
      value={{
        fairPaySurveyResponse,
        setFairPaySurveyResponse,
        fairPaySurveyPartnerships,
        setFairPaySurveyPartnerships,
      }}
    >
      {children}
    </FairPaySurveyResponseContext.Provider>
  );
};

export { FairPaySurveyResponseProvider, FairPaySurveyResponseContext };
